export function getRandInt0to9() {
    return getRandomInt({ max: 9 })
}

export function getRandInt0to10() {
    return getRandomInt({ max: 10 })
}

export function getRandInt0to99() {
    return getRandomInt({ max: 99 })
}

export function getRandInt0to100() {
    return getRandomInt({ max: 100 })
}

export function getRandInt1to10() {
    return getRandomInt({ max: 10, min: 1 })
}

export function getRandInt1to100() {
    return getRandomInt({ max: 100, min: 1 })
}

export function getRandomInt({ max, min = 0 }) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}